import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { User } from 'src/app/models/models';
import { AtivacoesService } from 'src/app/services/ativacoes.service';
import { SecurityService } from 'src/app/services/security.service';

@Component({
  selector: 'app-painel',
  templateUrl: './painel.component.html',
  styleUrls: ['./painel.component.scss'],
})
export class PainelComponent implements OnInit {
  ativacoes_realizadas;
  total_ativacoes;

  user: User;

  constructor(
    public securityService: SecurityService,
    public ativacoesService: AtivacoesService,
    private $gaService: GoogleAnalyticsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.securityService.currentUser.subscribe((user) => {
      this.user = user;
    });
    this.$gaService.pageView('/', 'Dashboard');
  }

  playCampaign(campaign: any) {
    this.router.navigate(['campanha'], {
      queryParams: { campaignName: campaign.campanha },
    });
  }

  getTotalAtivacoes() {
    let total_ativacoes = 0;
    this.securityService.currentUserValue?.resumoAtivacoes?.campanhas.forEach(
      (item) => {
        total_ativacoes += item.quantidade_aberta + item.quantidade_ativada;
      }
    );
    return total_ativacoes < 0 ? 0 : total_ativacoes;
  }

  getDiferencaAtivacoes(tipoMetrica) {
    let total_ativacoes = 0;
    let ativacoes_realizadas = 0;
    this.securityService.currentUserValue?.resumoAtivacoes?.campanhas.forEach(
      (item) => {
        item.quantidade_aberta =
          item.quantidade_aberta < 0 ? 0 : item.quantidade_aberta;
        total_ativacoes += item.quantidade_aberta + item.quantidade_ativada;
        ativacoes_realizadas += item.quantidade_ativada;
      }
    );
    if (tipoMetrica === 'porcentagem') {
      return Math.round((ativacoes_realizadas / total_ativacoes) * 100);
    }
    if (tipoMetrica === 'diferenca') {
      return total_ativacoes - ativacoes_realizadas;
    }
    if (tipoMetrica === 'realizadas') {
      return ativacoes_realizadas;
    }
  }

  arredondar(valor) {
    return Math.round(valor);
  }

  arredondarCima(valor) {
    return Math.ceil(valor);
  }
}
